import { Component, HostListener, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  DATE_OPTIONS,
  DateOptions,
  Scorecard,
  ScorecardDescription,
  ScorecardDisplayType,
  ScorecardMilestone,
  ScorecardMilestoneActionDisplayType,
  ScorecardMilestoneDetails,
  TermsAndCondtionsType,
  ScorecardAction,
  ScorecardActionType,
} from '@fgb/core';
import { ScorecardCategoryPunchcardView } from '../../../scorecard-categories';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-scorecard-description-actions',
  templateUrl: './scorecard-description-actions.component.html',
  styleUrl: './scorecard-description-actions.component.scss',
})
export class ScorecardDescriptionActionsComponent implements OnChanges {
  @Input() scorecardDescription: ScorecardDescription;

  scorecardDisplayType = ScorecardDisplayType;
  TermsAndCondtionsType = TermsAndCondtionsType;
  allActionSpacing: number[] = [];
  maxMilestone: number = 0;
  allMilestoneSpacing: number[] = [];
  currentProgressValue: number = 0;
  alignmentOfMilestoneValue = 0;
  alignmentOfMilestoneCircle = 0;
  category = ScorecardCategoryPunchcardView;
  lineBreakIndex: number;
  showMore: boolean = false;
  showTermsAndConditions = false;
  showDescription = true;
  firstChange: boolean = false;
  isMilestoneNotReachedTwoLastest: boolean = false;
  alignMilestoneNotReachedTwoLastest: number = 0;
  scorecardMilestone: Scorecard;
  toggleActions: any[] = [];

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private router: Router,
    private offcanvasService: NgbOffcanvas
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.scorecardDescription.currentValue.currentScorecard) {
      this.getContentOfScoreCard();
    }
  }

  // slice milestone into 3 actions if milesone have more than 3 action
  sliceMilestone(milestone: ScorecardMilestone) {
    if (!milestone) return {} as any;
    let newMilestone = JSON.parse(JSON.stringify(milestone)) as ScorecardMilestone;
    let milestones = newMilestone.Milestones;
    let currentValue = newMilestone.CustomerValue;
    let milestoneLength = milestones.length;
    let lastValueOriginMilestone = milestones[milestones.length - 1];
    let isSegmentMilestone = newMilestone.MilestoneActionDisplayType == ScorecardMilestoneActionDisplayType.segment;
    if (isSegmentMilestone && milestoneLength > 3) {
      // no action is done, length = 3
      if (currentValue == 0) {
        milestones.length = 3;
      }
      // some actions are done but still have more than 2 actions, get current and two more
      if (currentValue && currentValue <= milestoneLength - 2) {
        milestones = milestones.slice(currentValue - 1, currentValue + 2);
      }
      // only have one more action
      if (currentValue && currentValue == milestoneLength - 1) {
        milestones = milestones.slice(currentValue - 2, currentValue + 1);
      }
      // if milestone not reached two last step, set isMilestoneNotReachedTwoLastest = true to push circle and value to left
      if (lastValueOriginMilestone !== milestones[milestones.length - 1]) {
        this.isMilestoneNotReachedTwoLastest = true;
      }
      // if milestone is done, get 3 lastest
      if (currentValue == milestones.length) {
        milestones = milestones.slice(-3);
      }
    }

    newMilestone.Milestones = milestones;

    return newMilestone;
  }

  resetData() {
    this.maxMilestone = 0;
    this.allMilestoneSpacing = [];
    this.currentProgressValue = 0;
    this.scorecardMilestone = {} as Scorecard;
  }

  getContentOfScoreCard() {
    this.getActionSpacing();

    if (!!this.scorecardDescription.currentScorecard?.Milestone) {
      this.resetData();
      this.scorecardMilestone = Object.assign({}, this.scorecardDescription.currentScorecard);

      if (this.scorecardDescription.currentScorecard.ScoreCardDisplayType == 3) {
        this.maxMilestone = this.getMaxMilestone();
        this.scorecardMilestone.Milestone = this.sliceMilestone(this.scorecardDescription.currentScorecard.Milestone);
        this.getMilestoneSpacing();
        this.getCurrentValueOfProgressBar();
        this.getMilestoneValueSpacing(window.screen.width);
      }
    }

    this.lineBreakIndex = Math.floor(this.scorecardDescription?.currentScorecard?.Actions?.length / 2) - 1;
    this.firstChange = true;
  }

  get invisibleShowMore() {
    if (
      this.scorecardDescription.isCompleted &&
      this.scorecardDescription.currentScorecard.PrizeOptions &&
      !this.scorecardDescription.currentScorecard.PrizeOptions?.CustomerHasSelected
    )
      return false;
    else {
      return true;
    }
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  toggleShowAction(item: ScorecardAction) {
    const itemId = item.ScorecardActionId;
    const index = this.toggleActions.findIndex((action) => action.ScorecardActionId === itemId);

    if (index > -1) {
      this.toggleActions.splice(index, 1);
    } else {
      this.toggleActions.push(item);
    }
  }

  isActionToggled(action: ScorecardAction): boolean {
    return this.toggleActions.some((item) => item.ScorecardActionId === action.ScorecardActionId);
  }

  isLoyaltyActionIdValid(LoyaltyActionId: number): boolean {
    return Object.values(ScorecardActionType).includes(LoyaltyActionId);
  }

  executeAction(action: ScorecardAction) {
    const actionId = action.LoyaltyActionId;
    this.offcanvasService.dismiss();
    switch (actionId) {
      case ScorecardActionType.marketplace:
        this.router.navigate(['/rewards/marketplace']);
        break;

      case ScorecardActionType.auction:
        this.router.navigate(['/rewards/auctions']);
        break;

      case ScorecardActionType.lotto:
        this.router.navigate(['/rewards/raffles']);
        break;

      case ScorecardActionType.polls:
        this.router.navigate(['/games/polls']);
        break;

      case ScorecardActionType.trivia:
        this.router.navigate(['/games/trivia']);
        break;

      case ScorecardActionType.predictor:
        this.router.navigate(['/games/predictor']);
        break;
    }
  }

  showDescriptionActive() {
    this.showDescription = true;
    this.showTermsAndConditions = false;
  }
  showTermsAndConditonsActive() {
    this.showDescription = false;
    this.showTermsAndConditions = true;
  }

  getActionSpacing() {
    this.scorecardDescription?.currentScorecard?.Actions.forEach((action, i) => {
      let spacingCalculated = ((i + 1) / this.scorecardDescription?.currentScorecard?.Actions.length) * 100;
      let spacingPercentage = spacingCalculated;
      this.allActionSpacing.push(spacingPercentage);
    });
  }

  /**
   * Calculate value of
   * progress bar.
   */
  getCurrentValueOfProgressBar() {
    this.currentProgressValue = 0;
    if (this.scorecardMilestone.Milestone.MilestoneActionDisplayType === ScorecardMilestoneActionDisplayType.segment) {
      this.calculateProgressBySegment();
    } else {
      this.currentProgressValue = (this.scorecardMilestone.Milestone.CustomerValue * 100) / this.maxMilestone;
    }
  }

  /**
   * Calculate value of
   * progress bar by segment.
   */
  calculateProgressBySegment() {
    let differenceBetweenMilestones = (1 / this.scorecardMilestone.Milestone.Milestones.length) * 100;

    this.scorecardMilestone.Milestone.Milestones.every((milestone, i) => {
      if (this.scorecardMilestone.Milestone.CustomerValue >= milestone.Value) {
        this.currentProgressValue = this.allMilestoneSpacing[i];

        return true;
      } else {
        let currentSegmentTotal = 0;
        let progressInCurrentSegment = 0;

        if (i === 0) {
          currentSegmentTotal = this.scorecardMilestone.Milestone.Milestones[0].Value;
          progressInCurrentSegment = this.scorecardMilestone.Milestone.CustomerValue;
        } else {
          currentSegmentTotal = milestone.Value - this.scorecardMilestone.Milestone.Milestones[i - 1].Value;
          progressInCurrentSegment =
            this.scorecardMilestone.Milestone.CustomerValue - this.scorecardMilestone.Milestone.Milestones[i - 1].Value;
        }
        this.currentProgressValue =
          this.currentProgressValue + (progressInCurrentSegment / currentSegmentTotal) * differenceBetweenMilestones;

        return false;
      }
    });
  }

  /**
   * Gets max milestone value from
   * the highest value of milestones.
   * @returns Max milestone value
   */
  getMaxMilestone() {
    return Math.max.apply(
      Math,
      this.scorecardDescription?.currentScorecard.Milestone?.Milestones?.map(function (milestone: ScorecardMilestoneDetails) {
        return milestone.Value;
      })
    );
  }

  /**
   * Get accurate spacing
   * between milestones.
   * Will calculate spacing
   * depending on milestone display
   * type. e.g. segment view or
   * value view.
   */
  getMilestoneSpacing() {
    this.scorecardMilestone?.Milestone?.Milestones?.forEach((action: any, i: any) => {
      let spacingCalculated = 0;
      if (this.scorecardMilestone.Milestone.MilestoneActionDisplayType === ScorecardMilestoneActionDisplayType.segment) {
        spacingCalculated = ((i + 1) / this.scorecardMilestone.Milestone.Milestones.length) * 100;
      } else {
        spacingCalculated = (this.scorecardMilestone.Milestone.Milestones[i].Value / this.maxMilestone) * 100;
      }
      this.allMilestoneSpacing.push(spacingCalculated);
    });
  }

  /**
   * Calculate spacing
   * between milestone values
   * under the progress bar
   * according to screen size.
   */
  @HostListener('window:resize', ['$event.target.screen.width'])
  getMilestoneValueSpacing(event: number) {
    if (event > 991) {
      this.alignmentOfMilestoneValue = 2;
      this.alignmentOfMilestoneCircle = 3;
      this.alignMilestoneNotReachedTwoLastest = 2;
    }
    if (event <= 991 && event > 425) {
      this.alignmentOfMilestoneValue = 1.5;
      this.alignmentOfMilestoneCircle = 2.5;
      this.alignMilestoneNotReachedTwoLastest = 3;
    }
    if (event <= 425) {
      this.alignmentOfMilestoneCircle = 4.5;
      this.alignmentOfMilestoneValue = 3;
      this.alignMilestoneNotReachedTwoLastest = 4;
    }
  }
}
